export default function reducer(state = [], action) {
  switch (action.type) {
    case 'FILTERS/SET':
      return action.filters;
    case 'FILTERS/CLEAR':
      return null;    
    default:
      return state;
  }
}